<template>
  <div class="ddu-fields">
    <div class="dd-upload-group">
      <label class="dd-upload">
        <div
          class="dd-upload__zone"
          :class="{ 'dd-upload__zone--has-file': getFileName('front') }"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 8l-5-5-5 5M12 3v12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span v-if="getFileName('front')" class="dd-upload__filename">
            {{ getFileName("front") }}
          </span>
          <span v-else class="dd-upload__hint">
            {{ hasBack ? "Frente" : "Selecionar arquivo" }}
          </span>
        </div>
        <input
          type="file"
          accept="image/*,.pdf"
          class="dd-upload__input"
          @change="handleFileSelect($event, 'front')"
        />
      </label>

      <label v-if="hasBack" class="dd-upload">
        <div
          class="dd-upload__zone"
          :class="{ 'dd-upload__zone--has-file': getFileName('back') }"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17 8l-5-5-5 5M12 3v12"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span v-if="getFileName('back')" class="dd-upload__filename">
            {{ getFileName("back") }}
          </span>
          <span v-else class="dd-upload__hint">Verso</span>
        </div>
        <input
          type="file"
          accept="image/*,.pdf"
          class="dd-upload__input"
          @change="handleFileSelect($event, 'back')"
        />
      </label>
    </div>

    <button
      class="btn btn--primary btn--sm dd-card__submit"
      :disabled="!canSubmit || loading"
      @click="submit"
    >
      {{ submitLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: "DoctorDocumentUploadFields",
  props: {
    hasBack: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    submitLabel: { type: String, default: "Enviar documento" },
    partial: { type: Boolean, default: false }
  },
  data() {
    return {
      selectedFiles: {}
    };
  },
  methods: {
    handleFileSelect(event, side) {
      const file = event.target.files[0];
      if (!file) return;
      this.$set(this.selectedFiles, side, file);
    },

    getFileName(side) {
      return this.selectedFiles[side] ? this.selectedFiles[side].name : null;
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    async submit() {
      if (!this.canSubmit) return;

      const payload = {};
      if (this.selectedFiles.front) {
        payload.front = {
          data: await this.fileToBase64(this.selectedFiles.front)
        };
      }
      if (this.hasBack && this.selectedFiles.back) {
        payload.back = {
          data: await this.fileToBase64(this.selectedFiles.back)
        };
      }

      this.$emit("submit", payload);
      this.selectedFiles = {};
    }
  },
  computed: {
    canSubmit() {
      if (this.partial) {
        return !!(this.selectedFiles.front || this.selectedFiles.back);
      }
      if (!this.selectedFiles.front) return false;
      if (this.hasBack && !this.selectedFiles.back) return false;
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.dd-upload-group {
  display: flex;
  gap: var(--space-3);
}

.dd-upload {
  flex: 1;
  cursor: pointer;
  margin: 0;

  &__input {
    display: none;
  }

  &__zone {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-1);
    padding: var(--space-4) var(--space-3);
    border: 1.5px dashed var(--color-gray-300);
    border-radius: var(--radius-md);
    background: var(--color-gray-50);
    text-align: center;
    transition: border-color 0.15s, background 0.15s;
    min-height: 80px;
    color: var(--color-gray-400);

    &:hover {
      border-color: var(--color-primary);
      background: var(--color-primary-light);
      color: var(--color-primary);
    }

    &--has-file {
      border-color: var(--color-success);
      background: var(--color-success-light);
      color: var(--color-success);
    }
  }

  &__hint {
    font-size: var(--font-size-xs);
    font-weight: var(--fw-semibold);
    line-height: 1.3;
  }

  &__filename {
    font-size: var(--font-size-xs);
    font-weight: var(--fw-semibold);
    word-break: break-all;
    line-height: 1.3;
  }
}

.ddu-fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);

  .dd-card__submit {
    align-self: flex-start;
  }
}
</style>
